/* eslint-disable @typescript-eslint/no-var-requires */
import IconHelperProps from './IconHelperTypes'

const SETTINGS_ICON = require('../../assets/settings/settings-i-os.png')
const NOTIFICATIONS_ICON = require('../../assets/settings/notification-i-os.png')
const APP_ICON = require('../../assets/settings/sport-1-app-icon.png')

const PUSH_SETTINGS_ICONS = {
    settingsIcon: SETTINGS_ICON,
    notificationsIcon: NOTIFICATIONS_ICON,
    appIcon: APP_ICON,
} as IconHelperProps
export default PUSH_SETTINGS_ICONS
